import { styled } from "@mui/material/styles";
import { separatorLightGrey } from "../../styles/customColors";

const StyledOption = styled("li")({
	padding: "10px !important",
	borderBottom: `1px solid ${separatorLightGrey}`
});

export { StyledOption };
